import { generalAxios } from "@/plugins/axios";

export const STATIC_PAGES = {
  about: {
    apiSlug: "about",
    route: "/home/static-pages/about",
    publicRoute: "/pages/about",
    titleKey: "STATIC_PAGES.about",
  },
  terms: {
    apiSlug: "terms",
    route: "/home/static-pages/terms",
    publicRoute: "/pages/terms",
    titleKey: "STATIC_PAGES.terms",
  },
  privacy: {
    apiSlug: "privacy",
    route: "/home/static-pages/privacy",
    publicRoute: "/pages/privacy",
    titleKey: "STATIC_PAGES.privacy",
  },
  returnTerms: {
    apiSlug: "returnTerms",
    route: "/home/static-pages/return-terms",
    publicRoute: "/pages/return-terms",
    titleKey: "STATIC_PAGES.returnTerms",
  },
  howDeleteApp: {
    apiSlug: "how-delete-app",
    route: "/home/static-pages/how-delete-app",
    publicRoute: "/pages/how-delete-app",
    titleKey: "STATIC_PAGES.howDeleteApp",
  },
  contact: {
    route: "/home/static-pages/contact",
    publicRoute: "/pages/contact",
    titleKey: "STATIC_PAGES.contact",
  },
};

export async function fetchStaticPageContent(apiSlug, locale = "ar") {
  const res = await generalAxios({
    method: "GET",
    url: `page/${apiSlug}`,
    headers: {
      "Accept-Language": locale,
    },
  });

  return res.data?.data?.[0] || "";
}

export async function fetchContactUs() {
  const res = await generalAxios({
    method: "GET",
    url: "contact-us",
  });

  return res.data?.data?.[0] || {};
}
